module.exports = __webpack_public_path__ + "static/library-b862617c465139c1d77eb3579418443e.png";